<span class="fixed-top fixed_top_0">
    <nav [hidden]='!globals.isAuthenticated' class="header-fix  " [ngClass]="'bg-'+globals.colorTheme">
        <!-- <mat-grid-list cols="12" rowHeight="35px" >
                <mat-grid-tile [colspan]="4" class="postion-fix-left" >
                    <a class=" text-white ta-header-agrissales" routerLink="/home">
                        <h5>AGRIS Sales <span>{{ProRightsText}}</span> <span>{{ctdText}}</span></h5>                                             
                    </a>
                    <br>                                 
                </mat-grid-tile>
                <mat-grid-tile   [colspan]="6" > 
                    <div class="text-white ta-header-agrissales postion-fix-right-2percent" (click)="openDialog()" >
                        Location :
                        <button mat-button class="text-white mat-button"  style="text-decoration: underline;"  extended  
                            aria-label="ta-header-icon Location-icon icon" routerLink="" 
                            matTooltip="{{LocationCodeDV}}"
                            > 
                              {{LocationDVCode}}                                                    
                         </button>
                                       
                    </div>
                </mat-grid-tile> 
                <mat-grid-tile [colspan]="2">
                    <button class="humbuger ta-header-menu" mat-icon-button [matMenuTriggerFor]="menu"
                    (click)="getPermissions()">
                    <mat-icon style="font-size:30px">menu</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button class="ta-menu-home" mat-menu-item routerLink="/home">
                        <mat-icon>house</mat-icon>
                        <span> Home </span>
                    </button>
                    <button class="ta-menu-sales" mat-menu-item routerLink="/booking">
                        <mat-icon>book</mat-icon>
                        <span>Sales</span>
                    </button>
                    <button *ngIf="isSalesOrderAllow" class=" ta-menu-order" mat-menu-item routerLink="/order">
                        <mat-icon>menu_book</mat-icon>
                        <span>Order</span>
                    </button>
                    <button class="ta-menu-quantites" mat-menu-item routerLink="/items">
                        <mat-icon>shopping_basket</mat-icon>
                        <span>Quantities</span>
                    </button>
                    <button *ngIf="isBookAllow" class="ta-menu-quotes" mat-menu-item routerLink="/quotes">
                        <mat-icon>credit_card</mat-icon>
                        <span>{{QuoteButtonName}}</span>
                    </button>
                    <button class="ta-menu-settings" mat-menu-item routerLink="/settings">
                        <mat-icon>settings</mat-icon>
                        <span>Settings</span>
                    </button>
                    <button class="ta-menu-logout" mat-menu-item (click)="logout()">
                        <mat-icon class="text-danger">power_settings_new</mat-icon>
                        <strong class="text-danger">Logout</strong>
                    </button>
                </mat-menu>
                </mat-grid-tile>             
              </mat-grid-list> -->

        <div class="Navcontainer">
            <div class="parts pl-1">
                <a class="text-white ta-header-agrissales" [routerLink]="['/home']">
                    <h5>AGRIS Sales <span>{{ProRightsText}}</span> <span>{{ctdText}}</span></h5>
                </a>
                <br>
            </div>
            <div class="parts ">

            </div>
            <div class="parts  ta-header-menu">
                <div class=" text-white ta-header-agrissales postion-fix-right-2percent">
                    <!-- Location :
                        <a class="text-white"  style="text-decoration: underline;"  extended  
                            aria-label="ta-header-icon Location-icon icon" routerLink="" >                           
                            {{LocationCodeDV}} 
                        </a> -->
                    <div (click)="openDialog()">
                        Location :
                        <button mat-button class="text-white mat-button" style="text-decoration: underline;" extended
                            aria-label="ta-header-icon Location-icon icon" matTooltip="{{LocationCodeDV}}">
                            {{LocationDVCode}}
                        </button>
                    </div>
                    <div>
                        <button class="postion-fix-right-5px-top-31px ta-header-menu pt-0" mat-icon-button
                            [matMenuTriggerFor]="menu" (click)="getPermissions()">
                            <mat-icon style="font-size:30px">menu</mat-icon>
                        </button>
                    </div>
                </div>



                <mat-menu #menu="matMenu">
                    <button class="ta-menu-home" mat-menu-item routerLink="/home">
                        <mat-icon>house</mat-icon>
                        <span> Home </span>
                    </button>
                    <button class="ta-menu-sales" mat-menu-item routerLink="/booking">
                        <mat-icon>book</mat-icon>
                        <span>Sales</span>
                    </button>
                    <button *ngIf="isSalesOrderAllow" class=" ta-menu-order" mat-menu-item routerLink="/order">
                        <mat-icon>menu_book</mat-icon>
                        <span>Order</span>
                    </button>
                    <button class="ta-menu-quantites" mat-menu-item routerLink="/items">
                        <mat-icon>shopping_basket</mat-icon>
                        <span>Quantities</span>
                    </button>
                    <button *ngIf="isBookAllow" class="ta-menu-quotes" mat-menu-item routerLink="/quotes">
                        <mat-icon>credit_card</mat-icon>
                        <span>{{QuoteButtonName}}</span>
                    </button>
                    <button class="ta-menu-settings" mat-menu-item routerLink="/settings">
                        <mat-icon>settings</mat-icon>
                        <span>Settings</span>
                    </button>
                    <button class="ta-menu-logout" mat-menu-item (click)="logout()">
                        <mat-icon class="text-danger">power_settings_new</mat-icon>
                        <strong class="text-danger">Logout</strong>
                    </button>
                </mat-menu>
            </div>
        </div>
    </nav>




    <!-- Navbar -->

    <!-- <mat-toolbar class="header-fix navbar navbar-toggleable-md overlay-content" [ngClass]="'bg-'+globals.colorTheme">
            <mat-toolbar-row>
                <span>
                    <a class="navbar-brand text-white ta-header-agrissales" routerLink="/home">
                        <h5>AGRIS Sales <span>{{ProRightsText}}</span> <span>{{ctdText}}</span></h5>
                    </a>
                   
                </span>
                <span class="example-spacer">
                     <div class=" text-white ta-header-agrissales postion-fix-right-2percent" (click)="openDialog()" >
                        Location :
                        <a class="text-white"  style="text-decoration: underline;"  extended  
                            aria-label="ta-header-icon Location-icon icon" routerLink="" >                           
                            {{LocationCodeDV}} 
                        </a>
                                       
                    </div>
                </span>
                <span>
                    <button class="humbuger ta-header-menu" mat-icon-button [matMenuTriggerFor]="menu"
                        (click)="getPermissions()">
                        <mat-icon style="font-size:30px">menu</mat-icon>
                    </button>
                </span>
                <mat-menu #menu="matMenu">
                    <button class="ta-menu-home" mat-menu-item routerLink="/home">
                        <mat-icon>house</mat-icon>
                        <span> Home </span>
                    </button>
                    <button class="ta-menu-sales" mat-menu-item routerLink="/booking">
                        <mat-icon>book</mat-icon>
                        <span>Sales</span>
                    </button>
                    <button *ngIf="isSalesOrderAllow" class=" ta-menu-order" mat-menu-item routerLink="/order">
                        <mat-icon>menu_book</mat-icon>
                        <span>Order</span>
                    </button>
                    <button class="ta-menu-quantites" mat-menu-item routerLink="/items">
                        <mat-icon>shopping_basket</mat-icon>
                        <span>Quantities</span>
                    </button>
                    <button *ngIf="isBookAllow" class="ta-menu-quotes" mat-menu-item routerLink="/quotes">
                        <mat-icon>credit_card</mat-icon>
                        <span>{{QuoteButtonName}}</span>
                    </button>
                    <button class="ta-menu-settings" mat-menu-item routerLink="/settings">
                        <mat-icon>settings</mat-icon>
                        <span>Settings</span>
                    </button>
                    <button class="ta-menu-logout" mat-menu-item (click)="logout()">
                        <mat-icon class="text-danger">power_settings_new</mat-icon>
                        <strong class="text-danger">Logout</strong>
                    </button>
                </mat-menu>
            </mat-toolbar-row>
          
        </mat-toolbar> -->
</span>
<div *ngIf="!isOnline" class="overlay">
    <div class="overlay-content">
        You're offline. Check your connection!
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<br>
<alert-message class="pt-6"></alert-message>
<footer class="w-100">
    <small data-hj-whitelist>
        Version : {{version}} - {{AgentName}}
    </small>
</footer>
<app-loading-overlay />